import _ from "lodash";
import { colors, responsiveFontSizes } from "@mui/material";
import { enUS } from "@mui/material/locale";
import { THEMES } from "src/constants";
import { softShadows, strongShadows } from "./shadows";
import typography from "./typography";
import { createTheme as createMuiTheme } from "@mui/material/styles";

const baseOptions = {
    direction: "ltr",
    typography,
    components: {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    overflow: "hidden",
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 32,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(0,0,0,0.075)",
                },
            },
        },
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
        },
    },
};

const themesOptions = [
    {
        name: THEMES.LIGHT,
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        "&::placeholder": {
                            opacity: 1,
                            color: colors.blueGrey[600],
                        },
                    },
                },
            },
        },
        palette: {
            mode: "light",
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: colors.common.white,
                dark: "#f4f6f8",
                paper: colors.common.white,
            },
            primary: {
                main: "#2e7d32",
            },
            secondary: {
                main: "#ff8f00",
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.ONE_DARK,
        palette: {
            mode: "dark",
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                hover: "rgba(255, 255, 255, 0.04)",
                selected: "rgba(255, 255, 255, 0.08)",
                disabled: "rgba(255, 255, 255, 0.26)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                focus: "rgba(255, 255, 255, 0.12)",
            },
            background: {
                default: "#1a472a",
                dark: "#0d2818",
                paper: "#1a472a",
            },
            primary: {
                main: "#81c784",
            },
            secondary: {
                main: "#ffb74d",
            },
            text: {
                primary: "#e6e5e8",
                secondary: "#adb0bb",
            },
        },
        shadows: strongShadows,
    },
    {
        name: THEMES.UNICORN,
        palette: {
            mode: "dark",
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                hover: "rgba(255, 255, 255, 0.04)",
                selected: "rgba(255, 255, 255, 0.08)",
                disabled: "rgba(255, 255, 255, 0.26)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                focus: "rgba(255, 255, 255, 0.12)",
            },
            background: {
                default: "#2a2d3d",
                dark: "#222431",
                paper: "#2a2d3d",
            },
            primary: {
                main: "#a67dff",
            },
            secondary: {
                main: "#a67dff",
            },
            text: {
                primary: "#f6f5f8",
                secondary: "#9699a4",
            },
        },
        shadows: strongShadows,
    },
];

export const createTheme = (config = {}) => {
    let themeOptions = themesOptions.find(theme => theme.name === config.theme);

    if (!themeOptions) {
        console.warn(new Error(`The theme ${config.theme} is not valid`));
        [themeOptions] = themesOptions;
    }

    let theme = createMuiTheme(
        _.merge({}, baseOptions, themeOptions, { direction: config.direction }, enUS)
    );

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};
